import { Injectable } from '@angular/core';
declare const APIGateway: any;
import { from } from 'rxjs';
import * as environment from '../environments/environment';

interface OrgAppId {
    orgId: string;
    appId: string;
}

@Injectable({
    providedIn: 'root'
})
export class GatewayService {
    public apiGateway: any;
    private storageApi: any;
    constructor() {
        this.apiGateway = new APIGateway();
        this.apiGateway.config(this.getConfiguration());
        this.storageApi = this.apiGateway.getStorageAPI();
    }

    async storeIndexDbApi(key: string, value: any) {
        return await this.storageApi.setItem(key, value);
    }

    async getIndexDbApi(key) {
        return await this.storageApi.getItemValue(key);
    }

    async claerIndexDbApi(key) {
        return await this.storageApi.clear(key);
    }

    private CallApiClient(body, headers): any {
        // doPost return the Promise and filtered response
        return from(this.apiGateway.doPost(environment.environment, body, headers));
    }

    getConfiguration() {
        return {
            //Enable Logging in API GATEWAY
            logging: false,
            // Enable Service Worker
            serviceWorker: true,
            // Enable Service Worker on LocalHost
            activeSWOnLocalHost: false,
            // Enable Encryption
            encryption: true,
            // Can Configure Storage according to your project,a) sessionStorage b) localStorage c) IndexDB
            storage: 'sessionStorage',
            networkDriver: 'FETCH'
        };
    }

    callApiClientURL(body, headers, url): any {
        return from(this.apiGateway.doPostByUrl(environment, body, headers, url));
    }

    public callApiByUrl(body, header, url): any {
        return this.callApiClientURL(body, header, url);
    }

    public callApi(body, header): any {
        return this.CallApiClient(body, header);
    }

    public getOrgAppId(): OrgAppId {
        const data = environment.environment['envProps'];
        const obj = {
            orgId: data['orgId'],
            appId: data['appId']
        }
        return obj;
    }

    public callApiClientURLDownloadDms(body): any {
        const headers = {
            orgid: environment.environment['envProps']['orgId'],
            appid:environment.environment['envProps']['appId'],
            // clientsecret: '02d4665d-fece-4d97-a02b-60e1cccbca4c',
            loginid: '12345',
            requestid: '12345',
            storageid:environment.environment['envProps']['storageId']
            // storageid: 'DECIMAL-LDKJW5D1R2~SAARATHI-0MY7TA7QRA~bpg-decimal~S3~K51K5AVISJ'
        }
        return from(this.apiGateway.doPost(environment.environment, body, headers));
    }


    public uploadFile(body): any {
        // const env =
        // {
        //     production: true,
        //     envProps: {
        //         appId: 'SAARATHI-0MY7TA7QRA',
        //         // appVersion: '1.0',
        //         baseUrl: 'https://sandbox.vahanacloud.com/router/engine/v1',
        //         // baseUrl: 'https://saarathi.vahanacloud.com/router/engine/v1',
        //         orgId: 'DECIMAL-LDKJW5D1R2',
        //         platform: 'WEB',
        //         secureKey: '02d4665d-fece-4d97-a02b-60e1cccbca4c',
        //         securityVersion: '2',

        //         lat: 28.4162012,
        //         lon: 77.0909696
        //     },
        //     env: 'prod'
        // }
        return from(this.apiGateway.getDMSAPI().uploadFile(environment.environment, body, {}));
    }

    public updateFilesMetaData(body): any {
        const headers = {
            orgid: environment.environment['envProps']['orgId'],
            appid:environment.environment['envProps']['appId'],
            storageid:environment.environment['envProps']['storageId'],
        }
        return from(this.apiGateway.doPostByUrl(environment.environment, body, headers,'/VAHANA-DMS/document-manager/update/v1/updateMDO'));
    }

    public callApiClientURLDms(body, loginId): any {
        const headers = {
            orgid: environment.environment['envProps']['orgId'],
            appid: environment.environment['envProps']['appId'],
            loginid: loginId,
            requestid: loginId,
            storageid: environment.environment['envProps']['storageId']
        }
        return from(this.apiGateway.doPostByUrl(environment.environment, body, headers,
            '/upload-file/VAHANA-DMS/document-manager/upload/v1/uploadDocumentAndGetUrl'));
    }

    public callApiClientURLDeleteDms(body): any {
        const headers = {
            orgid: environment.environment['envProps']['orgId'],
            appid: environment.environment['envProps']['appId'],
            requestid: '12345',
            storageid: environment.environment['envProps']['storageId']
        }

        return from(this.apiGateway.doPost(environment.environment, body, headers));
    }

    public CallApiClientWithoutParsing(body, headers): any {
        return from(this.apiGateway.doPostWithoutParsing(environment, body, headers));
    }

}
